import { render, staticRenderFns } from "./NewNodeDialog.vue?vue&type=template&id=5450636a&scoped=true"
import script from "./NewNodeDialog.vue?vue&type=script&lang=js"
export * from "./NewNodeDialog.vue?vue&type=script&lang=js"
import style0 from "./NewNodeDialog.vue?vue&type=style&index=0&id=5450636a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450636a",
  null
  
)

export default component.exports